<template>
  <el-select
    class="w-100"
    size="small"
    v-bind="$attrs"
    :value="selectedValueInternal"
    filterable
    clearable
    @focus="fetchOptions"
    @change="handleSelectChange"
    :loading="isLoading"
  >
    <template v-if="options.length > 0">
      <el-option
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :value="option.id"
      ></el-option>
    </template>
  </el-select>
</template>

<script>
export default {
  props: {
    url: String,
    value: String,
    opt: Array
  },
  data() {
    return {
      options: [],
      loaded: false,
      currentUrl: this.url,
      selectedValueInternal: '',
    };
  },
  computed: {
    isLoading() {
      return !this.loaded;
    },
  },
  watch: {
    value(newValue) {
      this.selectedValueInternal = newValue || '';
    },
    url(newUrl) {
      this.handleUrlChange(newUrl);
    },
    opt(newOpt) {
      if (newOpt && newOpt.length > 0) {
        this.options = newOpt;
        this.loaded = true;
        this.setSelectedValue();
      }
    },
  },
  methods: {
    handleUrlChange(newUrl) {
      if (this.currentUrl !== newUrl) {
        this.loaded = false;
        this.currentUrl = newUrl;
        this.fetchOptions();
      }
    },
    handleValueChange(newValue) {
      this.selectedValueInternal = newValue || '';
      if (!this.options.length && !this.opt && newValue) {
        this.fetchOptions();
      }
    },
    fetchOptions() {
      if (!this.loaded) {
        this.axios
          .get(this.currentUrl)
          .then((response) => {
            this.options = response.data;
            this.$emit('options-loaded', this.options);
          })
          .catch((error) => {
            console.error('Erro ao carregar opções:', error);
          })
          .finally(() => {
            this.loaded = true;
          });
      }
    },
    handleSelectChange(selectedValues) {
      this.selectedValueInternal = selectedValues;
      this.$emit('input', this.selectedValueInternal);
    },
    setSelectedValue() {
      // Define o valor do v-model após o carregamento da lista
      if (this.value && this.options.some(option => option.id === this.value)) {
        this.selectedValueInternal = this.value;
      }
    },
  },
};
</script>
